import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

import 'swiper/css';


const swiperNavigationOptions: Pick<SwiperOptions, 'navigation'> = {
	navigation: {
		nextEl: '[data-role=next-button]',
		prevEl: '[data-role=prev-button]',
	}
};

new Swiper('[data-role=products]', {
	modules: [Navigation],
	slidesPerView: 1.47,
	spaceBetween: '20px',
	breakpoints: {
		768: {
	        slidesPerView: 2,
			spaceBetween: '23px',
		},
		1280: {
	        slidesPerView: 4,
			spaceBetween: '23px',
		}
	},
	...swiperNavigationOptions
});

new Swiper('[data-role=banners]', {
	modules: [Navigation],
	slidesPerView: 'auto',
	spaceBetween: '20px',
	...swiperNavigationOptions
});